/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : RouterLink.jsx
 * description   : {{insert here}}
 * creation date : 19/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Link as ReactRouterLink,
} from 'react-router-dom';

import {
    View,
    Text,
    Link,
    Button,
} from '@aws-amplify/ui-react';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function RouterLink({ to, isExternal, children, ...rest }) {
    return (
        <Fragment>
            <View
                width='fit-content'
            >
                <ReactRouterLink
                    component={Link}
                    to={to}
                    target={isExternal ? '_blank' : ''}
                    {...rest}
                >
                    {children}
                </ReactRouterLink>
            </View>
        </Fragment>
    );
}

function LinkText({ to, isExternal, children, ...rest }) {
    return (
        <Fragment>
            <RouterLink
                to={to}
                isExternal={isExternal}
                className='router-link-text'
            >
                <Text
                    {...rest}
                >
                    {children}
                </Text>
            </RouterLink>
        </Fragment>
    );
}

function LinkButton({ to, isExternal, children, ...rest }) {
    return (
        <Fragment>
            <RouterLink
                to={to}
                isExternal={isExternal}
            >
                <Button
                    {...rest}
                >
                    {children}
                </Button>
            </RouterLink>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    RouterLink,
    LinkText,
    LinkButton,
};



// End of file
